<template>
  <div class="parametros">

    <!-- Congregación -->
    <div class="section-card">
      <div class="section-header">
        <i class="pi pi-building section-icon" />
        <div>
          <div class="section-title">Congregación</div>
          <div class="section-desc">{{ territorios.congregacion || 'Sin nombre configurado' }}</div>
        </div>
      </div>
      <Button
        icon="pi pi-cog"
        label="Gestionar congregación"
        outlined
        size="small"
        @click="showCongregacionModal = true"
      />
    </div>
    <GestionarCongregacionModal v-model:visible="showCongregacionModal" />

    <!-- Grupos de Predicación -->
    <div class="section-card">
      <div class="section-header">
        <i class="pi pi-users section-icon" />
        <div>
          <div class="section-title">Grupos de Predicación</div>
          <div class="section-desc">
            {{ territorios.grupos.length }} grupo{{ territorios.grupos.length === 1 ? '' : 's' }} configurado{{ territorios.grupos.length === 1 ? '' : 's' }}
          </div>
        </div>
      </div>
      <Button
        icon="pi pi-cog"
        label="Gestionar grupos"
        outlined
        size="small"
        @click="showGruposModal = true"
      />
    </div>
    <GestionarGruposModal v-model:visible="showGruposModal" />

    <!-- Zonas (otras congregaciones) -->
    <div class="section-card">
      <div class="section-header">
        <i class="pi pi-sitemap section-icon" />
        <div>
          <div class="section-title">Zonas</div>
          <div class="section-desc">
            {{ territorios.zonas.length }} zona{{ territorios.zonas.length === 1 ? '' : 's' }} configurada{{ territorios.zonas.length === 1 ? '' : 's' }}
          </div>
        </div>
      </div>
      <Button
        icon="pi pi-cog"
        label="Gestionar zonas"
        outlined
        size="small"
        @click="showZonasModal = true"
      />
    </div>
    <GestionarZonasModal v-model:visible="showZonasModal" />

    <!-- Conductores -->
    <div class="section-card">
      <div class="section-header">
        <i class="pi pi-car section-icon" />
        <div>
          <div class="section-title">Conductores de salidas</div>
          <div class="section-desc">
            {{ salida.conductores.length }} conductor{{ salida.conductores.length === 1 ? '' : 'es' }} configurado{{ salida.conductores.length === 1 ? '' : 's' }}
          </div>
        </div>
      </div>
      <Button
        icon="pi pi-cog"
        label="Gestionar conductores"
        outlined
        size="small"
        @click="showConductoresModal = true"
      />
    </div>
    <GestionarConductoresModal v-model:visible="showConductoresModal" />

    <!-- Mapa de Google -->
    <div class="section-card">
      <div class="section-header">
        <i class="pi pi-map section-icon" />
        <div>
          <div class="section-title">Mapa de Google</div>
          <div class="section-desc">{{ usarGoogle ? 'Activado' : 'Desactivado' }}</div>
        </div>
      </div>
      <Button
        icon="pi pi-cog"
        label="Gestionar mapa de Google"
        outlined
        size="small"
        @click="showMapaGoogleModal = true"
      />
    </div>
    <GestionarMapaGoogleModal v-model:visible="showMapaGoogleModal" />

    <!-- Puntos de Encuentro -->
    <div class="section-card">
      <div class="section-header">
        <i class="pi pi-map-marker section-icon" />
        <div>
          <div class="section-title">Puntos de Encuentro</div>
          <div class="section-desc">
            {{ territorios.puntoEncuentro.length }} punto{{ territorios.puntoEncuentro.length === 1 ? '' : 's' }} configurado{{ territorios.puntoEncuentro.length === 1 ? '' : 's' }}
          </div>
        </div>
      </div>
      <Button
        icon="pi pi-cog"
        label="Gestionar puntos de encuentro"
        outlined
        size="small"
        @click="showPuntosModal = true"
      />
    </div>
    <GestionarPuntosEncuentroModal v-model:visible="showPuntosModal" />

    <!-- Impresión de salidas -->
    <div class="section-card">
      <div class="section-header">
        <i class="pi pi-print section-icon" />
        <div>
          <div class="section-title">Impresión de salidas</div>
          <div class="section-desc">Colores, tipografía y logo de la hoja impresa</div>
        </div>
      </div>
      <Button
        icon="pi pi-cog"
        label="Personalizar impresión"
        outlined
        size="small"
        @click="showImpresionModal = true"
      />
    </div>
    <GestionarImpresionModal v-model:visible="showImpresionModal" />

    <!-- Apariencia del menú -->
    <div class="section-card">
      <div class="section-header">
        <i class="pi pi-table section-icon" />
        <div>
          <div class="section-title">Menú</div>
          <div class="section-desc">Posición del menú en la vista de escritorio (en mobile no cambia)</div>
        </div>
      </div>
      <SelectButton
        v-model="menuLayoutSelection"
        :options="menuLayoutOptions"
        optionLabel="label"
        optionValue="value"
        :allowEmpty="false"
      />
    </div>

    <!-- Mi cuenta -->
    <div class="section-card">
      <div class="section-header">
        <i class="pi pi-user section-icon" />
        <div>
          <div class="section-title">Mi cuenta</div>
          <div class="section-desc">Cambiá tu contraseña o tu usuario de acceso</div>
        </div>
      </div>
      <Button
        icon="pi pi-cog"
        label="Gestionar cuenta"
        outlined
        size="small"
        @click="showCuentaModal = true"
      />
    </div>
    <GestionarCuentaModal v-model:visible="showCuentaModal" />

    <!-- 2FA -->
    <div class="section-card">
      <div class="section-header">
        <i class="pi pi-shield section-icon" />
        <div>
          <div class="section-title">Seguridad</div>
          <div class="section-desc">Configuración de autenticación de dos factores</div>
        </div>
      </div>
      <Button
        icon="pi pi-cog"
        label="Gestionar seguridad"
        outlined
        size="small"
        @click="showSeguridadModal = true"
      />
    </div>
    <GestionarSeguridadModal v-model:visible="showSeguridadModal" />

    <!-- Usuarios de la congregación -->
    <div class="section-card" v-if="userStore.hasCongregation">
      <div class="section-header">
        <i class="pi pi-users section-icon" />
        <div>
          <div class="section-title">Usuarios de la congregación</div>
          <div class="section-desc">Agregá, editá o eliminá usuarios de tu congregación</div>
        </div>
      </div>
      <Button
        icon="pi pi-cog"
        label="Gestionar usuarios"
        outlined
        size="small"
        @click="showUsuariosModal = true"
      />
    </div>
    <GestionarUsuariosModal v-model:visible="showUsuariosModal" />

  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useSalidaStore } from "@/store/useSalidaStore";
import { useTerritoriosStore } from "@/store/territorios";
import { useUserStore } from "@/store/useUserStore";
import { useMapPrefs } from "@/composables/useMapPrefs";
import { useMenuLayoutStore } from "@/store/useMenuLayoutStore";
import GestionarGruposModal from "@/components/GestionarGruposModal.vue";
import GestionarConductoresModal from "@/components/GestionarConductoresModal.vue";
import GestionarZonasModal from "@/components/GestionarZonasModal.vue";
import GestionarPuntosEncuentroModal from "@/components/GestionarPuntosEncuentroModal.vue";
import GestionarUsuariosModal from "@/components/GestionarUsuariosModal.vue";
import GestionarCongregacionModal from "@/components/GestionarCongregacionModal.vue";
import GestionarMapaGoogleModal from "@/components/GestionarMapaGoogleModal.vue";
import GestionarCuentaModal from "@/components/GestionarCuentaModal.vue";
import GestionarSeguridadModal from "@/components/GestionarSeguridadModal.vue";
import GestionarImpresionModal from "@/components/GestionarImpresionModal.vue";

const salida = useSalidaStore();
const territorios = useTerritoriosStore();
const userStore = useUserStore();
const { googleEnabled } = useMapPrefs();
const menuLayoutStore = useMenuLayoutStore();

const usarGoogle = computed(() => googleEnabled.value);

const menuLayoutOptions = [
  { label: "Lateral", value: "lateral" },
  { label: "Superior", value: "top" },
];
const menuLayoutSelection = computed({
  get: () => menuLayoutStore.layout,
  set: (value) => menuLayoutStore.setLayout(value),
});

const showGruposModal = ref(false);
const showConductoresModal = ref(false);
const showZonasModal = ref(false);
const showPuntosModal = ref(false);
const showUsuariosModal = ref(false);
const showCongregacionModal = ref(false);
const showMapaGoogleModal = ref(false);
const showCuentaModal = ref(false);
const showSeguridadModal = ref(false);
const showImpresionModal = ref(false);
</script>

<style scoped>
.parametros {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
  align-items: stretch;
}

.section-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  padding: 1.25rem 1.25rem 1rem;
  box-shadow: var(--shadow-1);
  border: none;
}

.section-header {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.section-icon {
  font-size: 1.1rem;
  color: var(--accent);
  margin-top: 2px;
  flex-shrink: 0;
}

.section-title {
  font-weight: var(--weight-semibold);
  font-size: var(--text-title-3);
  color: var(--label-primary);
  line-height: 1.3;
}

.section-desc {
  font-size: var(--text-footnote);
  color: var(--label-secondary);
  margin-top: 2px;
  line-height: 1.4;
}
</style>
